var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecgnitionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 259,
    viewBox: "0 0 259 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1584_5089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00195312 0H258.998V259H-0.00195312V0Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5664 109.427H98.8453V206.811H55.5664V109.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9688 77.0267C51.9688 63.3126 63.0928 52.2015 76.8069 52.2015C90.5209 52.2015 101.645 63.3126 101.645 77.0267C101.645 90.7407 90.5209 101.852 76.8069 101.852C63.0928 101.852 51.9688 90.7278 51.9688 77.0267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.766 55.3224H207.045V98.6013H163.766V55.3224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.658 55.3224H152.937V206.799H109.658V55.3224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.766 109.427H207.045V152.706H163.766V109.427Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_5089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259,
    height: 259,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecgnitionLogo);
export default __webpack_public_path__ + "static/media/recgnitionLogo.965fcabf51d8413448243868ee58fd0a.svg";
export { ForwardRef as ReactComponent };